import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ApexColumnChart from '../../../components/charts/ApexColumnChart';
import { Icons } from '../../../components/base/BootstrapComponents';
import { CAMERA_STATUS } from '../../Camera/constants';
import { getClientData } from '../../Client/reducer';

export default function CameraMeterStatCard({ data }) {
  const {
    count: {
      ERROR = 0,
      WARNING = 0,
      OK = 0,
    } = {
      ERROR: 0,
      WARNING: 0,
      OK: 0,
    },
    percent: {
      ERROR: errorPercent = 0,
      WARNING: warningPercent = 0,
      OK: okPercent = 0,
    } = {
      ERROR: 0,
      WARNING: 0,
      OK: 0,
    },
    total = 0,
  } = data;
  const { clientData } = useSelector(getClientData);
  const { permission_keys } = clientData;
  const navigate = useNavigate();
  const series = OK + WARNING + ERROR > 0 ? [[OK, WARNING, ERROR]] : [[]];
  const columnDistributedChartData = {
    series,
    labels: ['Исправен', 'Некритическая поломка', 'Неисправен'],
    loading: false,
  };

  const handleColumnClick = (a, b, c) => {
    const config = [
      CAMERA_STATUS.OK,
      CAMERA_STATUS.WARNING,
      CAMERA_STATUS.ERROR,
    ];
    if (permission_keys && permission_keys.length) {
      const a = ['frontend_menu_camera'].every(routePermission => !!permission_keys.find(item => item === routePermission));
      if (a && c && c.dataPointIndex >= 0) {
        navigate(`/cameras?status=${config[c.dataPointIndex]}&clearOther=1`);
      }
    }
  };

  return (
    <div className="frame">
      <div className="dashboard-stat-card">
        <div className="dashboard-stat-chart">
          <ApexColumnChart
            {...columnDistributedChartData}
            title="Камеры видеонаблюдения"
            className=""
            distributed
            height={170}
            hideLegend
            onClick={handleColumnClick}
          />
        </div>
        <div className="dashboard-stat-text">
          <div className="parking-meter-state">
            <div className="parking-meter-state-wrapper">
              <Icons width={109} height={84} customIcon icon="parking-cam" className="parking-meter-state-icons parking-cam" />
            </div>
            <div className="parking-meter-text">
              <div className="parking-meter-text-1 f5">
                <span className="pmw-number"><span className="pmw-count">{WARNING + ERROR}</span> из {total}</span><br />
                видеокамер требуют<br />
                внимания
              </div>
              <div className="parking-meter-state-percent">{Number(errorPercent + warningPercent).toFixed(0)}%</div>
            </div>
          </div>
          <div className="parking-meter-state-text">неисправных видеокамер</div>
        </div>
      </div>
    </div>

  );
}
